<template>
  <div v-loading="loading" element-loading-text="Connecting..." class="dashboard">
    <claim :scanning.sync = "scanning"></claim>
    <a class="float-button" @click="scanning=true;"><float-button></float-button></a>
    <div v-if="noProducts" class="sorry">
      <div v-if="unconfirmeds.length === 0">Please claim your 1st asset.</div>
    </div>
    <div class="products-wrapper">
      <div class="item-wrapper plus-button">
        <dashboard-plus-button @click.native="claim"></dashboard-plus-button>
      </div>
      <div class="item-wrapper" v-for="transaction in unconfirmeds" :key="transaction.meta.hash.data">
        <dashboard-item-loading>
        </dashboard-item-loading>
      </div>
      <div class="item-wrapper" v-for="(product, index) in products" :key="index">
        <dashboard-item :product="product"
          :imgUrl="getImgUrl(product)"
          @onItemClick="openProduct(product.address)">
        </dashboard-item>
      </div>
    </div>
  </div>
</template>

<script>
// TODO: refactor the request to get all the transaction
// if it's more than 25
import { PlusIcon } from 'vue-feather-icons';
import VueContentLoading from 'vue-content-loading';
import getUrls from 'get-urls';
// import luxtagApi from '../API/index';
import EventBus from '../Buss/EventBus';
import nem from '../../static/js/index';
import noPreview from '../assets/img/no-preview-available.jpg';

const DashboardItem = () => import('./DashboardItem');
const DashboardPlusButton = () => import('./DashboardPlusButton');
const DashboardItemLoading = () => import('./DashboardItemLoading');
const Claim = () => import('./Claim');
const FloatButton = () => import('./FloatButton');

export default {
  data() {
    return {
      noPreview,
      address: '',
      connector: null,
      unconfirmeds: [],
      products: [],
      noProducts: false,
      loading: false,
      active: true,
      scanning: false,
      hover: false,
    };
  },
  methods: {
    getImgUrl(product) {
      const urls = getUrls(JSON.stringify(product)); // return Set data type
      let imageUrl = [...urls][0];
      if (!imageUrl) {
        imageUrl = this.noPreview;
      }
      return imageUrl;
    },
    openProduct(address) {
      this.$router.push(`/product/${address}`);
    },
    claim() {
      if (this.active) {
        this.scanning = true;
      } else {
        this.$message({
          message: 'Please activate your account to be able to claim assets',
          type: 'error',
        });
      }
    },
    processConfirmedTransaction(trs) {
      // checking the data type of unconfirmed transaction
      const that = this;
      if (trs.transaction.type === 4097) {
        // claim transaction
        that.unconfirmeds.splice(0, 1);
      } else if (trs.transaction.type === 4100) {
        if (trs.transaction.otherTrans.type === 4097) {
          // transfer transcation
          const trans = trs.transaction.otherTrans;
          if (trans.modifications[0].cosignatoryAccount === this.$store.getters.getAuth.PP) {
            // transferred to this account
            that.unconfirmeds.splice(0, 1);
          } else if (trans.modifications[1].cosignatoryAccount === that.$store.getters.getAuth.PP) {
            // transferred to other account
            const address = nem.model.address.toAddress(
              trans.signer, nem.model.network.data.mainnet.id);
            for (let i = 0; i < that.products.length; i += 1) {
              if (that.products[i].address === address) {
                // remove transferred product from list products
                that.products.splice(i, 1);
                break;
              }
            }
          }
        }
      }
    },
    processUnconfirmedTransaction(trs) {
      // checking the data type of confirmed transaction
      const that = this;
      if (trs.transaction.type === 4097) {
        // claim transaction
        that.unshiftToUnconfirmeds(trs);
      } else if (trs.transaction.type === 4100) {
        if (trs.transaction.otherTrans.type === 4097) {
          // transfer transcation
          const trans = trs.transaction.otherTrans;
          if (trans.modifications[0].cosignatoryAccount === this.$store.getters.getAuth.PP) {
            // transferred to this account
            that.unshiftToUnconfirmeds(trs);
          }
        }
      }
    },
    unshiftToUnconfirmeds(trs) {
      // add new loading product to the beginning of unconfirmeds
      const that = this;
      let contain = false;
      // prevent duplicate unconfirmed
      for (let i = 0; i < that.unconfirmeds.length; i += 1) {
        if (that.unconfirmeds[i].meta.hash.data === trs.meta.hash.data) {
          contain = true;
        }
      }
      if (contain === false) {
        // add to unconfirmed timeline
        that.unconfirmeds.unshift(trs);
      }
    },
    connect(connector) {
      const that = this;
      const nemSocket = nem.com.websockets;
      // to close the connector before leaving the route
      EventBus.$on('close', () => {
        connector.close();
        that.loading = false;
      });
      that.loading = true;
      // display this message once
      that.$message({
        message: 'Connecting to the blockchain..',
        type: 'info',
        showClose: true,
      });
      return connector.connect().then(() => {
        // here we are connected to the NIS
        that.$message({
          message: 'Connection established',
          type: 'success',
          showClose: true,
        });
        // we subscribe to errors channel first
        nemSocket.subscribe.errors(connector, (res) => {
          that.$notify({
            message: JSON.stringify(res),
            type: 'error',
          });
        });

        // Subscribe to account data channel
        nem.com.websockets.subscribe.account.data(connector, (response) => {
          // store response
          // still not sure where should we use this
          that.$store.commit('SET_RESPONSE', response);

          if (response.meta.cosignatoryOf.length === 0) {
            that.noProducts = true;
          } else {
            that.noProducts = false;
          }

          for (let i = 0; i < response.meta.cosignatoryOf.length; i += 1) {
            nem.com.requests.account.transactions.incoming(
              that.$store.getters.getEndpoints.web[that.endPointIndex],
              response.meta.cosignatoryOf[i].address)
            .then((trs) => {
              const payload = trs.data[trs.data.length - 1].transaction.message.payload;
              const productMeta = JSON.parse(nem.utils.format.hexToUtf8(payload));
              productMeta.address = response.meta.cosignatoryOf[i].address;
              // prevent duplicateing the product on the dashboard
              let contain = false;
              for (let j = 0; j < that.products.length; j += 1) {
                if (that.products[j].tag === productMeta.tag) {
                  contain = true;
                }
              }
              if (contain === false) {
                that.products.unshift(productMeta);
                // that.unconfirmeds.splice(0, 1);
              }
            }, (e) => {
              that.$notify({
                message: e,
                type: 'error',
                duration: 0,
              });
            });
          }
        });

        // Subscribe to unconfirmed transactions channel
        nemSocket.subscribe.account.transactions.unconfirmed(connector, (res) => {
          that.processUnconfirmedTransaction(res);
        });

        // Subscribe to unconfirmed transactions channel
        nemSocket.subscribe.account.transactions.confirmed(connector, (res) => {
          that.processConfirmedTransaction(res);
        });

        // Request account data
        nemSocket.requests.account.data(connector);

        // Request recent transactions
        nemSocket.requests.account.transactions.recent(connector);
        that.loading = false;
      }, (err) => { // eslint-disable-line  padded-blocks
        // Try to reconnect
        that.reconnect();
        // }
        that.$notify({
          message: JSON.stringify(err),
          type: 'error',
          duration: 0,
        });
      }).catch((err) => {
        // Try to reconnect
        that.reconnect();
        that.$message({
          message: 'Connection ERROR',
          type: 'error',
          showClose: true,
        });
      });
    },
    reconnect(connector) {
      const that = this;
      let endPointIndex = this.endPointIndex;
      const nemSocket = nem.com.websockets;
      // closing the connectore before leaving the route
      EventBus.$on('close', () => {
        that.connector.close();
        that.loading = false;
      });
      endPointIndex += 1;
      if (endPointIndex >= that.maxNodes) {
        endPointIndex = 0;
      }
      that.$store.commit('SET_ENDINDEX', endPointIndex);

      that.loading = true;
      // Replace connector with a new endpoint
      that.connector = nemSocket.connector.create(
        that.$store.getters.getEndpoints.websocket[endPointIndex],
        that.address);
      that.$message({
        message: 'Trying to reconnect...',
        type: 'info',
        showClose: true,
      });
      // Try to establish a connection
      that.connect(that.connector);
    },
  },
  computed: {
    maxNodes() {
      return this.$store.getters.getEndpoints.websocket.length;
    },
    endPointIndex() {
      return this.$store.getters.getEndpointIndex;
    },
  },
  beforeCreate() {
    EventBus.$emit('loading-stop');
  },
  created() {
    const that = this;

    // display the webcam from the slide mene
    EventBus.$on('scanning', () => {
      this.scanning = true;
    });

    const nemSocket = nem.com.websockets;
    // the account Address to subscribe to
    this.address = this.$store.getters.getAccounts[this.$store.getters.getAuth.index]
                        .accounts[0].address;
    // push the address to the store
    this.$store.commit('PUSH_ADDRESS', this.address);
    // tests
    // this.address = 'TAJKGSZGPEVBF4XDTFPDV5IT5FZRMZSGUDW3KSJT';
    // Create a websocket connector object
    // https://github.com/QuantumMechanics/NEM-sdk/blob/master/examples/browser/websockets/script.js
    this.connector = nemSocket.connector.create(
      this.$store.getters.getEndpoints.websocket[this.endPointIndex],
      this.address);

    // connecting to the NIS starts here
    this.connect(that.connector);
  },
  mounted() {
    /* const that = this;
    luxtagApi.user.isActive().then((response) => {
      if (typeof (response) === 'boolean') {
        that.active = response;
      }
    }); */
    EventBus.$emit('loading-stop');
  },
  beforeRouteLeave(to, from, next) {
    EventBus.$emit('close');
    next();
  },
  components: {
    PlusIcon,
    VueContentLoading,
    Claim,
    FloatButton,
    DashboardItem,
    DashboardPlusButton,
    DashboardItemLoading,
  },
};
</script>

<style lang="scss">
$break-small: 450px;
$break-medium: 769px;
.dashboard {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 22px;
  @media only screen and (min-width: $break-small)  { 
    padding: 20px;
  }
  .float-button {
    @media only screen and (min-width: $break-medium)  { 
      display: none;
    }
  }
  .products-wrapper{
    display: grid; 
    grid-gap: 16px; 
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr) ) ; 
    @media only screen and (min-width: $break-small)  { 
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr) ) ; 
    }
    .item-wrapper {
      width: 100%;
      height: 400px;
    }
    .plus-button {
      @media only screen and (max-width: $break-medium)  { 
        display: none;
      }
    }
  }
  .sorry {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

</style>



// WEBPACK FOOTER //
// Dashboard.vue?1365168c